import React, { useContext, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

function RegisterForm() {
    const { register } = useContext(AuthContext);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const history = useHistory();

    const handleSubmit = async event => {
        event.preventDefault();
        if (password !== confirmPassword) return setError('The two passwords do not match.');
        if (password.length < 8) return setError('Use at least 8 characters for your password.');
        setSubmitting(true);
        setError('');
        const result = await register(username.trim(), password);
        setSubmitting(false);
        if (!result.success) return setError(result.error || 'Account creation failed.');
        history.push('/');
    };

    return (
        <main className="account-page"><section className="account-panel"><p className="eyebrow">Customer account</p><h1>Save your order history.</h1><p>Creating an account is optional, but makes tracking orders easier.</p><form onSubmit={handleSubmit}><label>Email or username<input value={username} onChange={event => setUsername(event.target.value)} autoComplete="username" required /></label><label>Password<span className="password-field"><input type={showPassword ? 'text' : 'password'} value={password} onChange={event => setPassword(event.target.value)} autoComplete="new-password" required /><button type="button" onClick={() => setShowPassword(current => !current)} aria-label={showPassword ? 'Hide password' : 'Show password'}>{showPassword ? <FaEyeSlash /> : <FaEye />}</button></span></label><label>Confirm password<input type={showPassword ? 'text' : 'password'} value={confirmPassword} onChange={event => setConfirmPassword(event.target.value)} autoComplete="new-password" required /></label>{error && <p className="form-error" role="alert">{error}</p>}<button className="button button--primary button--wide" disabled={submitting}>{submitting ? 'Creating account...' : 'Create account'}</button></form><p className="account-switch">Already registered? <Link to="/sign-in">Sign in</Link></p></section></main>
    );
}

export default RegisterForm;
